module.exports = __webpack_public_path__ + "img/carshina21_17.cdcf6f88.jpg";